module.exports = {
  title: 'Activity Log',
  table: {
    title: {
      index: 'No',
      module: 'Module',
      command: 'Command',
      activity: 'Activity',
      fullName: 'Full Name',
      email: 'Email',
      modifiedAt: 'Date',
      action: 'Action',
    },
  },
  detail: 'Detail',
};
